import * as React from "react"
import Svg, { SvgProps, Path } from "react-native-svg"
const MainExperienceScreenIcon = (props: SvgProps) => (
  <Svg
    width={64}
    height={54}
    fill="none"
    {...props}
  >
    <Path
      fill="#C0A46F"
      fillRule="evenodd"
      d="M57.79 0c0 3.01-2.44 5.45-5.45 5.45h-.004v.001h.003a5.45 5.45 0 0 1 5.451 5.451h.001c0-2.985 2.4-5.41 5.375-5.45A5.451 5.451 0 0 1 57.791 0V0ZM3.61 46.69a3.609 3.609 0 0 1-3.608 3.608H0h.002a3.609 3.609 0 0 1 3.609 3.609h.001a3.609 3.609 0 0 1 3.556-3.609 3.609 3.609 0 0 1-3.556-3.608h-.001Z"
      clipRule="evenodd"
    />
    <Path
      fill="#C0A46F"
      d="m20.006 42.014 17.186-8.147 8.146-17.186-17.186 8.147-8.146 17.186Zm12.666-9.248c-.95.048-1.757-.273-2.422-.961a3.416 3.416 0 0 1-.997-2.457c0-.95.328-1.757.983-2.422.655-.665 1.467-.997 2.436-.997.969 0 1.78.328 2.436.983.655.655.983 1.467.983 2.436 0 .968-.328 1.78-.983 2.435-.656.656-1.467.983-2.436.983Zm.029 21.082c-3.369 0-6.542-.637-9.521-1.912-2.979-1.274-5.587-3.03-7.825-5.265-2.238-2.235-3.994-4.84-5.27-7.814-1.275-2.974-1.913-6.151-1.913-9.532 0-3.382.637-6.55 1.911-9.505a24.818 24.818 0 0 1 5.265-7.79c2.236-2.237 4.84-3.993 7.814-5.269 2.974-1.276 6.152-1.913 9.533-1.913 3.381 0 6.55.637 9.505 1.911a24.818 24.818 0 0 1 7.789 5.265 24.74 24.74 0 0 1 5.27 7.797c1.275 2.963 1.913 6.129 1.913 9.497 0 3.37-.637 6.543-1.912 9.522-1.274 2.978-3.029 5.587-5.264 7.824a24.74 24.74 0 0 1-7.798 5.27c-2.963 1.276-6.128 1.914-9.497 1.914Zm-.03-2.28c6.173 0 11.42-2.16 15.74-6.48 4.321-4.321 6.482-9.568 6.482-15.74 0-6.173-2.16-11.42-6.481-15.74s-9.568-6.481-15.74-6.481c-6.173 0-11.42 2.16-15.74 6.48-4.32 4.322-6.481 9.568-6.481 15.74 0 6.173 2.16 11.42 6.481 15.74 4.32 4.321 9.567 6.482 15.74 6.482Z"
    />
  </Svg>
)
export default MainExperienceScreenIcon
